<div class="material-preview">
  @switch (checkMimeType(material.mimetype)) {
    @case ('video') {
      <app-video-preview [material]="material"></app-video-preview>
    }
    @case ('audio') {
      <app-audio-preview [material]="material"></app-audio-preview>
    }
    @case ('pdf') {
      <app-pdf-preview [material]="material"></app-pdf-preview>
    }
    @case ('html') {
      <app-html-preview [material]="material"></app-html-preview>
    }
    @case ('h5p') {
      <app-h5p-preview [material]="material" (loadFailed)="failedH5pPath = $event"></app-h5p-preview>
    }
    @case ('office') {
      <app-office-preview [material]="material"></app-office-preview>
    }
    @case ('image') {
      <app-image-preview [material]="material"></app-image-preview>
    }
    @default {
      @switch (lang) {
        @default {
          <em>
            Valittu tiedosto ei ole esikatseltavissa. Ota oppimateriaali käyttöön
            <a [href]="material.downloadUrl" download>lataamalla se</a>
            .
          </em>
        }
        @case ('en') {
          <em>
            The chosen file cannot be previewed. Please
            <a [href]="material.downloadUrl" download>download the material</a>
            to start using it.
          </em>
        }
        @case ('sv') {
          <em>
            Filen kan inte förhandsgranskas.
            <a [href]="material.downloadUrl" download>Ladda ner materialen</a>
            om du vill använda filen.
          </em>
        }
      }
    }
  }
</div>
